import { MAIL_GOOGLE_OAUTH_ENABLED } from "@/lib/constants/googleOAuth";
import { MAIL_MICROSOFT_OAUTH_ENABLED } from "@/lib/constants/microsoftOAuth";
import type { MailProviderPreset } from "@/lib/types/mail";

export const MAIL_CONNECT_QUICK_IDS = ["gmail", "microsoft", "manual"] as const;

export function mailConnectOtherProviders(
  providers: MailProviderPreset[]
): MailProviderPreset[] {
  return providers.filter((p) => !MAIL_CONNECT_QUICK_IDS.includes(p.id as (typeof MAIL_CONNECT_QUICK_IDS)[number]));
}

export function mailConnectFindProvider(
  providers: MailProviderPreset[],
  id: string
): MailProviderPreset | null {
  return providers.find((p) => p.id === id) ?? null;
}

export function mailConnectGmailOAuthAvailable(
  providers: MailProviderPreset[]
): boolean {
  if (!MAIL_GOOGLE_OAUTH_ENABLED) return false;
  const gmail = mailConnectFindProvider(providers, "gmail");
  return gmail?.oauthAvailable === true;
}

export function mailConnectMicrosoftOAuthAvailable(
  providers: MailProviderPreset[]
): boolean {
  if (!MAIL_MICROSOFT_OAUTH_ENABLED) return false;
  const microsoft = mailConnectFindProvider(providers, "microsoft");
  return microsoft?.oauthAvailable === true;
}

/** Gmail / Microsoft : plus de formulaire mot de passe d'app si OAuth est dispo. */
export function mailConnectIsOAuthOnlyProvider(
  provider: MailProviderPreset | null,
  providers: MailProviderPreset[]
): boolean {
  if (!provider) return false;
  if (provider.id === "gmail") return mailConnectGmailOAuthAvailable(providers);
  if (provider.id === "microsoft") return mailConnectMicrosoftOAuthAvailable(providers);
  return false;
}

